import { add, max, startOfDay, sub } from 'date-fns'
import { computed, ref, toValue, type MaybeRefOrGetter } from 'vue'

export type TimeSlotPickerQueryVars = {
  calendarGuid: string
  from: TimeString
  until: TimeString
}

const computeDays = (_start: Date, length: number): Date[] => {
  const start = startOfDay(_start)
  return Array.from({ length }, (_empty, index) => add(start, { days: index }))
}

export const useTimeSlotPickerQueryVars = (
  chunkSize: number,
  calendarGuid: MaybeRefOrGetter<string>
) => {
  const now = new Date()
  const cursor = ref(now)
  const daysInRange = computed(() => computeDays(cursor.value, chunkSize))
  const until = computed(() =>
    add(startOfDay(cursor.value), { days: chunkSize })
  )

  const queryVars = computed((): TimeSlotPickerQueryVars => ({
    calendarGuid: toValue(calendarGuid),
    from: cursor.value.toISOString() as TimeString,
    until: until.value.toISOString() as TimeString,
  }))

  const hasPrev = computed(() => cursor.value > now)
  const next = () => {
    cursor.value = until.value
  }
  const prev = () => {
    cursor.value = max([now, sub(cursor.value, { days: chunkSize })])
  }

  return { queryVars, daysInRange, hasPrev, next, prev }
}
